import axios from 'axios'
import Cookies from 'js-cookie'
import store from '@/store'
import router from '@/router'
import Swal from 'sweetalert2'

axios.interceptors.request.use(
  config => {
    const token = Cookies.get('token');
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }

    return config
  },
  error => Promise.reject(error)
)
// Response interceptor
axios.interceptors.response.use(response => response, error => {

  let status = 200;

  if (error.response) {
    status = error.response.status
  }

  if (status >= 500) {
    const {
      message,
      exception,
    } = error.response.data;
    Swal.fire({
      type: 'error',
      title: exception || status,
      text: (message && message.length) ? message : 'Whoops, looks like something went wrong.',
      reverseButtons: true,
      confirmButtonText: 'OK',
      confirmButtonColor: '#613975',
      cancelButtonText: 'CANCEL'
    })
  }

  if (status === 401 && store.getters.check) {
    Swal.fire({
      type: 'warning',
      title: 'Your session has expired. please log in!',
      text: '',
      reverseButtons: true,
      confirmButtonText: 'OK',
      confirmButtonColor: '#613975',
      cancelButtonText: 'CANCEL'
    }).then(() => {
      store.commit('SHOW_MODAL', false)
      store.commit('LOGOUT')
      router.push({ name: 'login' })
    })
  }

  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/plugins/interceptor.js